import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { QuestionAnswerService } from '../question-answer.service';
import { QuestionAnswer } from '../question-answer';
import { QuestionAnswerComponent } from '../question-answer/question-answer.component';

@Component({
    selector: 'app-question-answer-list',
    templateUrl: './question-answer-list.component.html',
    styleUrls: ['./question-answer-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class QuestionAnswerListComponent implements OnInit {
	constructor(
		private questionAnswerService: QuestionAnswerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = questionAnswerService.statuses
	}



	// data
	questionAnswers: any;
	questionAnswer: QuestionAnswer;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'questionAnswerId', header: 'Id', width: 'auto' },
		{ field: 'questionDesc', header: 'Question Description', width: 'auto' },
		{ field: 'answerDesc', header: 'Answer Description', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'section', header: 'Section', width: 'auto' },
		{ field: 'website', header: 'Website', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.questionAnswerId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-questionAnswer-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.questionAnswerService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.questionAnswers = res.data.questionAnswers;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.questionAnswers = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(questionAnswer: QuestionAnswer) {
		try {
			this.formLoading = true;
			this.questionAnswerService.update(questionAnswer)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.questionAnswers.map((questionAnswer, i) => {
							if (questionAnswer.questionAnswerId === res.data.questionAnswer.questionAnswerId) {
								this.questionAnswers[i] = res.data.questionAnswer;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(questionAnswer: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(questionAnswer));

			this.formLoading = true;
			this.questionAnswerService.delete(questionAnswer.questionAnswerId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.questionAnswers.splice(this.questionAnswers.indexOf(questionAnswer), 1);
						this.recordTotal = this.questionAnswers.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'QuestionAnswer ' + questionAnswer.questionAnswerId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'QuestionAnswer ' + questionAnswer.questionAnswerId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add QuestionAnswer'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuestionAnswerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addQuestionAnswerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(questionAnswer: QuestionAnswer) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			questionAnswer: questionAnswer,
			title: 'Edit QuestionAnswer'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuestionAnswerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateQuestionAnswerCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteQuestionAnswerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addQuestionAnswerCB(questionAnswer: QuestionAnswer) {
		console.log('Adding QuestionAnswer: ' + JSON.stringify(questionAnswer));
		// if we don't have a questionAnswers array yet...
		if (!this.questionAnswers) {
			this.questionAnswers = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.questionAnswers.unshift(questionAnswer);

		// no idea what this is but it is required to update the array
		this.questionAnswers = [...this.questionAnswers];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuestionAnswer ' + questionAnswer.questionAnswerId + ' Added', life: 3000 });
	}

	updateQuestionAnswerCB(questionAnswer: QuestionAnswer) {
		console.log('Updating QuestionAnswer: ' + JSON.stringify(questionAnswer));
		let itemIndex = this.questionAnswers.findIndex((item: any) => item.questionAnswerId === questionAnswer.questionAnswerId);
		this.questionAnswers[itemIndex] = questionAnswer;

		// no idea what this is but it is required to update the array
		this.questionAnswers = [...this.questionAnswers];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuestionAnswer ' + questionAnswer.questionAnswerId + ' Updated', life: 3000 });
	}

	deleteQuestionAnswerCB(questionAnswer: QuestionAnswer) {
		console.log('Removing QuestionAnswer: ' + questionAnswer);
		this.questionAnswers.splice(this.questionAnswers.indexOf(questionAnswer), 1);
		this.recordTotal = this.questionAnswers.length;

		// no idea what this is but it is required to update the array
		this.questionAnswers = [...this.questionAnswers];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'QuestionAnswer ' + questionAnswer.questionAnswerId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.questionAnswers ? this.first === (this.questionAnswers.length - this.rows) : true; }
	isFirstPage(): boolean { return this.questionAnswers ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(questionAnswer: any) {
		if (questionAnswer?.status) {
			const status = this.statuses.find((e: any) => e.value == questionAnswer.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
